import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType";

const initState = {
    groupName:'',
    groupMember:'',
    groupProject:'',
    dateRange:'',
}

export const groupWiseReportsConfig = {
    name: "Group Wise Reports",
    initialState: initState,
    section: [
        {
            sectionId: 'groupWiseReports',
            title: "Group Wise Reports",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-12 mb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>,
            fields: [
                {
                    id: "groupName",
                    label: "Group Name",
                    Field_Name: "Group Name",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "groupName",
                    isMultiSelect: true,
                    fieldSetting: {
                        placeholder: "Please Select Group",
                        allowSpace: true,
                        options: [],
                        isMultiSelect: false
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-3 validation-text-model",
                    },
                },

                {
                    id: "groupMember",
                    label: "Group Member",
                    Field_Name: "Group Member",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "groupMember",
                    isMultiSelect: true,
                    fieldSetting: {
                        placeholder: "Please Select Group Member",
                        allowSpace: true,
                        options: [],
                        isMultiSelect: true
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-3 validation-text-model",
                    },
                },

                {
                    id: "groupProject",
                    label: "Group Project",
                    Field_Name: "Group Project",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "groupProject",
                    isMultiSelect: true,
                    fieldSetting: {
                        placeholder: "Please Select Group Project",
                        allowSpace: true,
                        options: [],
                        isMultiSelect: true
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-3 validation-text-model",
                    },
                },

                {
                    id: "dateRange",
                    label: "Date Range",
                    Field_Name: "Date Range",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "dateRange",
                    isMultiSelect: true,
                    fieldSetting: {
                        placeholder: "Please Select Date",
                        dateConfig: {
                          singleInputRangePicker: true,
                          monthsToShow: 2,
                          format: "dd/MM/yyyy",
                      }
                      },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-3 validation-text-model",
                    },
                },
            ]
        }
    ]
} 